export default "__VITE_ASSET__Ywkz$BBc__"